<template lang="pug">
  .prod-image
    img.full-width(:src="image.url" :alt="image.alt_text")

</template>

<script>
  export default {
    name: "ProductInfoImage",
    props: {
      imagery: {
        type: Object,
        required: true,
        default: {}
      },
      primary: {
        type: String,
        required: false,
        default: 'backie'
      }
    },

    computed: {
      image() {
        var image = {
          url: '', //- needs default placeholder image
          alt_text: 'placeholder'
        };

        if (this.imagery[this.primary]) {
          image = this.imagery[this.primary];
        } else if (this.imagery.standard) {
          image = this.imagery.standard;
        } else if (this.imagery.thumb) {
          image = this.imagery.thumb;
        } else {
          image = this.placeholderImage;
        }

        return image || {};
      }
    }
   }
</script>

<style scoped lang="stylus">
  .prod-image
    background-color color-fog-light

    img
      vertical-align text-bottom

</style>
